export let CONTENT_RATINGS = /*#__PURE__*/function (CONTENT_RATINGS) {
  CONTENT_RATINGS["ALL"] = "all";
  CONTENT_RATINGS["MATURE"] = "mature";
  return CONTENT_RATINGS;
}({});
export const CONTENT_RATING_LIST = [CONTENT_RATINGS.ALL, CONTENT_RATINGS.MATURE];
//# sourceMappingURL=content-ratings.js.map